<template>
  <div>
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <vx-card>
      <vs-tabs
        alignment="fixed"
        v-model="activeTab"
        class="tab-action-btn-fill-conatiner"
      >
        <vs-tab :label="$t('admin.label.Online Payment')">
          <vs-table :max-items="10" pagination :data="onlinePayents" search>
            <template slot="header">
              <!-- <span class="vx-col order-1" style="margin-right: 10px">
                <v-select
                  label="text"
                  v-model="search.gateway"
                  placeholder="Select Search Option"
                  :options="searchItems"
                  @input="searchPayments"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </span> -->
              <span class="vx-col order-1">
                <v-select
                  label="text"
                  v-model="onlinePaymentStatus"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :options="searchSecondItems"
                  @input="changeOnlinePaymentStatus"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </span>
              <!-- searchPayments -->
              <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  size="small"
                  @click="fetchPaymentList"
                >
                  {{ $t("admin.label.Search") }}</vs-button
                >
              </span>
              <!-- <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  @click="bulkUploadsPopup = true"
                  size="small"
                >
                  {{ $t("admin.label.Download") }}</vs-button
                >
              </span>
              <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  icon="menu-icon"
                  @click="clickReprocess"
                  size="small"
                >
                  {{ $t("admin.label.Reprocess") }}</vs-button
                >
              </span> -->
            </template>
            <template slot="thead">
              <vs-th>{{ $t("admin.label.Payment Id") }}</vs-th>
              <vs-th>{{ $t("admin.label.Payment Date") }}</vs-th>
              <vs-th>{{ $t("admin.label.Email Id") }}</vs-th>
              <!-- <vs-th>{{ $t("admin.label.Serial No") }}</vs-th> -->
              <vs-th>{{ $t("admin.label.Receipt No") }}</vs-th>
              <vs-th>{{ $t("admin.label.Amount Paid") }}</vs-th>
              <vs-th>{{ $t("admin.label.Status") }}</vs-th>
              <vs-th>{{ $t("admin.label.currency_code") }}</vs-th>
              <vs-th>{{ $t("admin.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(uploads, index) in data">
                <vs-td :data="uploads.paymentId">{{ uploads.id }}</vs-td>
                <vs-td :data="getDate(uploads.paymentDate)">{{
                  getDate(uploads.paymentDate)
                }}</vs-td>
                <vs-td :data="uploads.phoneNo">{{ uploads.phoneNo }}</vs-td>
                <!-- <vs-td :data="uploads.serialNo"> {{ uploads.serialNo }}</vs-td> -->
                <vs-td :data="uploads.receiptNo">{{ uploads.receiptNo }}</vs-td>
                <vs-td :data="uploads.amountPaid">{{
                  uploads.amountPaid
                }}</vs-td>
                <vs-td :data="uploads.status">{{ uploads.status }}</vs-td>
                <vs-td :data="uploads.remarks">{{ uploads.remarks }}</vs-td>
                <vs-td>
                  <feather-icon
                    icon="EditIcon"
                    title="edit"
                    class="text-warning icon_row"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editUserData(uploads)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-tab>
        <vs-tab :label="$t('admin.label.autopay')"
          ><div class="vx-rowmx-1">
            <vs-table :max-items="10" pagination :data="autoPayPayments" search>
              <template slot="header">
                <!-- <span class="vx-col order-1" style="margin-right: 10px">
                <v-select
                  label="text"
                  v-model="search.gateway"
                  placeholder="Select Search Option"
                  :options="searchItems"
                  @input="searchPayments"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </span> -->
                <span class="vx-col order-1">
                  <v-select
                    label="text"
                    v-model="autoPayStatus"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :options="searchSecondItems"
                    @input="changeAutoPayStatus"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                </span>
                <!-- searchPayments -->
                <span class="vx-col order-1">
                  <vs-button
                    icon-pack="feather"
                    size="small"
                    @click="fetchPaymentList"
                  >
                    {{ $t("admin.label.Search") }}</vs-button
                  >
                </span>
                <!-- <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  @click="bulkUploadsPopup = true"
                  size="small"
                >
                  {{ $t("admin.label.Download") }}</vs-button
                >
              </span>
              <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  icon="menu-icon"
                  @click="clickReprocess"
                  size="small"
                >
                  {{ $t("admin.label.Reprocess") }}</vs-button
                >
              </span> -->
              </template>
              <template slot="thead">
                <vs-th>{{ $t("admin.label.client_id") }}</vs-th>
                <vs-th>{{ $t("admin.label.Payment Date") }}</vs-th>
                <vs-th>{{ $t("admin.label.Email Id") }}</vs-th>
                <!-- <vs-th>{{ $t("admin.label.Serial No") }}</vs-th> -->
                <vs-th>{{ $t("admin.label.Receipt No") }}</vs-th>
                <vs-th>{{ $t("admin.label.Amount Paid") }}</vs-th>
                <vs-th>{{ $t("admin.label.Status") }}</vs-th>
                <vs-th>{{ $t("admin.label.currency_code") }}</vs-th>
                <vs-th>{{ $t("admin.label.Action") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" v-for="(uploads, index) in data">
                  <vs-td :data="uploads.paymentId">{{
                    uploads.paymentId
                  }}</vs-td>
                  <vs-td :data="getDate(uploads.paymentDate)">{{
                    getDate(uploads.paymentDate)
                  }}</vs-td>
                  <vs-td :data="uploads.phoneNo">{{ uploads.phoneNo }}</vs-td>
                  <!-- <vs-td :data="uploads.serialNo">
                    {{ uploads.serialNo }}</vs-td
                  > -->
                  <vs-td :data="uploads.receiptNo">{{
                    uploads.receiptNo
                  }}</vs-td>
                  <vs-td :data="uploads.amountPaid">{{
                    uploads.amountPaid
                  }}</vs-td>
                  <vs-td :data="uploads.status">{{ uploads.status }}</vs-td>
                  <vs-td :data="uploads.remarks">{{ uploads.remarks }}</vs-td>
                  <vs-td>
                    <feather-icon
                      icon="EditIcon"
                      title="edit"
                      class="text-warning icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editUserData(uploads)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table></div
        ></vs-tab>
      </vs-tabs>
      <div>
        <h2 class="list-heading">{{ $t("admin.label.Online Payment") }}</h2>
      </div>
    </vx-card>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Download Payment Gateway')"
        :active.sync="bulkUploadsPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("admin.label.Select Payment Source")
                }}</small>
                <v-select
                  label="text"
                  :options="searchItems"
                  :v-model="downPdf.searchItems"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("admin.label.Status")
                }}</small>
                <v-select
                  label="text"
                  :options="searchSecondItems"
                  v-model="downPdf.searchSecondItems"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("admin.label.From Date")
                  }}<span class="required">*</span></small
                >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  class="mb-2 font-semibold"
                  v-model="downPdf.startDate"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("admin.label.To Date")
                  }}<span class="required">*</span></small
                >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  class="mb-2 font-semibold"
                  v-model="downPdf.endDate"
                />
              </div>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button
                style="margin-left: 220px"
                type="border"
                @click="bulkUploadsPopup = false"
                >{{ $t("admin.label.Cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="download">{{
                $t("admin.label.Confirm")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Ravepay reprocess')"
        :active.sync="reprocessPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full w-full mb-2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="transaction id"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('admin.label.Transaction Id')"
                    type="text"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button
                  style="margin-left: 220px"
                  type="border"
                  @click="reprocessPopup = false"
                  >{{ $t("admin.label.Cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="handleReprocess()">{{
                  $t("admin.label.Reprocess")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.EditPaymentGateway')"
        :active.sync="paymentEditPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold">{{
                    $t("admin.label.PaymentGatewayRemarks")
                  }}</small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="payment gateway remarks"
                    :key="resetKey"
                  >
                    <v-select
                      label="name"
                      v-model="getPayment.remarks"
                      :options="paymentStatus"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-col sm:w-full md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold">{{
                    $t("admin.label.Status")
                  }}</small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="status"
                    :key="resetKey"
                  >
                    <v-select
                      label="value"
                      v-model="getPayment.status"
                      :options="editTemplate.statusData"
                      :reduce="(status) => status.id"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button
                  style="margin-left: 220px"
                  type="border"
                  @click="paymentEditPopup = false"
                  >{{ $t("admin.label.Cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="saveEdit">{{
                  $t("admin.label.Save")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import Datepicker from "vuejs-datepicker";
import _ from "lodash";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { BUCKET_BASE_URL } from "@/http/index";
import { mapState } from "vuex";
const bulkUploadsObj = {
  name: "",
  description: "",
  file: null,
};
export default {
  data() {
    return {
      selectedSecondItem: "",
      selectedItem: "",
      loading: false,
      search: {
        gateway: null,
        payStatus: null,
      },
      editableId: "",
      resetKey: 0,
      bulkUploadsPopup: false,
      reprocessPopup: false,
      paymentEditPopup: false,
      bulkUploads: bulkUploadsObj,
      downPdf: {
        searchItems: "",
        searchSecondItems: "",
        startDate: moment().subtract(15, "d").format("DD MMMM YYYY"),
        endDate: moment().subtract(0, "d").format("DD MMMM YYYY"),
      },
      searchItems: ["All", "Mpesa", "Tigo"],
      searchSecondItems: [
        "All",
        "INITIATED",
        "Failed",
        "Success",
        "Finished",
        "Invalid",
        "Processed",
      ],
      onlinePaymentStatus: "",
      autoPayStatus: "",
      getPayment: {
        status: "",
        remarks: "",
      },
      uploadName: [
        { name: "Customer Activation" },
        { name: "Transfer" },
        { name: "CustomerRegistration" },
        { name: "Hardware Items" },
        { name: "Adjustments" },
        { name: "Payments" },
        { name: "MRN" },
        { name: "MoveItemsale" },
        { name: "EPG" },
        { name: "Transfer" },
        { name: "Media Assets" },
        { name: "Organization" },
        { name: "AddPlan" },
        { name: "ChangePlan" },
        { name: "CancelPlan" },
        { name: "ClientServiceSuspend" },
        { name: "ClientServicereactive" },
        { name: "MrnCarton" },
        { name: "Create Lead" },
        { name: "ServiceActivation" },
        { name: "ServicePlanActivation" },
        { name: "ClientServiceTermination" },
        { name: "Create User" },
        { name: "RenewalPlan" },
        { name: "EditCustomer" },
      ],
      paymentStatus: ["ACTIVE", "DONE"],
      activeTab: 0,
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      paymentData: (state) => state.admin.payments,
      onlinePayents: (state) => state.admin.onlinePayents,
      autoPayPayments: (state) => state.admin.autoPayPayments,
    }),
    editTemplate() {
      return this.$store.getters["admin/editPaymentList"];
    },
  },
  methods: {
    getDate(date) {
      return moment(date)
        .add(5, "hours")
        .add(30, "minutes")
        .format("DD-MM-YYYY HH:mm:ss");
    },
    clickReprocess() {
      this.reprocessPopup = true;
      this.resetKey++;
    },
    async handleReprocess() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
    },
    async searchPayments() {
      this.loading = true;
      try {
        this.$store.dispatch("admin/searchOnlinePayments", this.search);
      } catch (error) {
        this.$toasted.error(error.message);
      }
      this.loading = false;
    },
    async getDataUploads() {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/setOnlinePayment");
        // this.$store.dispatch("admin/setOnlinePayments", response.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    download() {
      let payload = {
        baseUrl: BUCKET_BASE_URL,
        searchItems: this.downPdf.searchItems,
        searchSecondItems: this.downPdf.searchSecondItems,
      };
      try {
        const fromDate = moment(this.downPdf.startDate).format("DD-MM-YYYY");
        const toDate = moment(this.downPdf.endDate).format("DD-MM-YYYY");
        this.$store.dispatch("admin/updateDownloadAction", payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editUserData(data) {
      this.getPayment.status = data.status;
      this.getPayment.remarks = data.remarks;
      this.paymentEditPopup = true;
      this.resetKey++;
    },
    async saveEdit() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;
      try {
        await this.$store.dispatch("admin/updatePaymentAction", {
          id: this.editableId,
          remarks: this.editableId,
          data: this.getPayment,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Jobs Updated successfully!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
      this.paymentEditPopup = false;
      this.getDataUploads();
    },
    createFormData(object) {
      let formData = new FormData();
      _.forEach(object, (value, key) => {
        formData.append(key, value);
      });
      return formData;
    },
    changeOnlinePaymentStatus(status) {
      this.onlinePaymentStatus = status;
      this.fetchPaymentList();
    },
    changeAutoPayStatus(status) {
      this.autoPayStatus = status;
      this.fetchPaymentList();
    },
    async fetchPaymentList() {
      let payload = {};
      if (this.activeTab == 0) {
        payload.paymentType = "Online";
        if (this.onlinePaymentStatus.length)
          payload.tabType = this.onlinePaymentStatus;
      } else {
        payload.paymentType = "AutoPay";
        if (this.autoPayStatus.length) payload.tabType = this.autoPayStatus;
      }

      try {
        await this.$store.dispatch("admin/setPaymentListByType", payload);
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
  },
  watch: {
    activeTab(newVal) {
      this.fetchPaymentList();
    },
  },
  async mounted() {
    this.fetchPaymentList();
    // this.getDataUploads();
  },
};
</script>
